<template>
  <article class="description-box">
    <figure class="description-box__image" :data-parallax="getRandomInt">
      <img v-lazy="switchImg" :alt="data.alt">
      <div
        v-lazy:background-image="switchImg"
      ></div>
    </figure>

    <div class="description-box__text">
      <h4 class="description-box__title" data-anim="title">
        {{ data.title }}
      </h4>
      <p
        v-for="text in data.description"
        :key="text"
        v-html="text"
        class="description-box__content"
        data-anim="text"
      >
        {{ text }}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'DescriptionBox',

  props: ['data'],

  computed: {
    getRandomInt() {
      const min = 0.02;
      const max = 0.08;
      return (Math.random() * (max - min)) + min;
    },

    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.data.url}.webp`;
      }
      return `${this.data.url}.jpg`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.description-box {
  position: relative;
  padding-top: 60px;

  // display: grid;
  // grid-template-columns: 100%;
  
  display: flex;
  flex-wrap: wrap;

  @include mq(sm) {
    padding-top: 80px;
    // grid-template-columns: 50% 50%;
  }

  &__image {
    width: 100%;
    height: 300px;
    padding: 0;
    margin: 0;

    overflow: hidden;

    @include mq(sm) {
      margin: 0 0 0 -40px;
    }

    flex: 0 0 100%;

    @include mq(sm) {
      flex: 0 0 calc(50% - 40px);
    }

    img {
      @include visually-hidden;
    }

    div {
      width: 100%;
      height: 100%;

      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  &__text {
    flex: 0 0 100%;

    @include mq(sm) {
      padding: 0 0 0 40px;
      flex: 0 0 calc(50% + 80px);
    }
  }

  &__title {
    padding: 40px 40px 0 40px;
    font-size: 1rem;

    @include mq(sm) {
      padding-top: 0px;
      margin-bottom: 20px;
    }
  }

  &__content {
    padding: 20px 40px 0 40px;

    @include mq(sm) {
      padding: 0 100px 0 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DescriptionBox.vue